import { BooleanInput, Button, useNotify, useRecordContext, useRefresh } from "react-admin";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { erasmusRequests } from "api/erasmusApi";
import { ErasmusApplicationStatuses } from "utils/constants";

const EditTransportDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const isClosed = record?.status === ErasmusApplicationStatuses.Closed;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      erasmusRequests.updateApplicationTransport(record?.id),
      {
        isGreenTransport: !!data.isGreenTransport,
        isSharedTransport: !!data.isSharedTransport,
      },
      "PUT",
    );
    notify("Транспортът е обновен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на транспорт"
      onConfirm={handleConfirm}
      defaultValues={{
        isGreenTransport: !!record?.isGreenTransport,
        isSharedTransport: !!record?.isSharedTransport,
      }}
      triggerButton={
        <Button
          variant="contained"
          color="inherit"
          size="medium"
          startIcon={<DirectionsBusIcon />}
          label="Редакция на транспорт"
          disabled={isClosed}
        />
      }
    >
      <BooleanInput
        source="isGreenTransport"
        label="Зелен транспорт"
      />
      <BooleanInput
        source="isSharedTransport"
        label="Споделен транспорт"
      />
    </FormModal>
  );
};

export default EditTransportDialog;
